import { ComponentInternalInstance, computed, getCurrentInstance, reactive, ref, Ref } from '@vue/composition-api';
import dayjs from 'dayjs';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { RULE_LIST_MAP, RULE_LIST_VALUE_MAP } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';

/**
 * 收集相关信息处理功能
 * @param collectToken
 */
export const collectInfoHandler = (collectToken: string) => {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const collectTask = reactive<SMH.CollectTaskData>({
    id: 0,
    nickname: '',
    userId: 0,
    avatar: '',
    title: '',
    describes: '',
    isPermanent: false,
    expireTime: '',
    status: 1,
    libraryId: '',
    fileType: [],
    code: '',
    namingRules: [],
    path: '',
    spaceId: '',
    spaceOrgId: '',
    exampleFiles: [],
    orgId: -1,
    orgLogo: '',
    orgName: '',
    showOrgNameInUI: undefined,
  });

  const orgLogoInfo = computed(() => {
    const { orgLogo, orgName, showOrgNameInUI } = collectTask;
    return {
      orgLogo,
      orgName,
      showOrgNameInUI,
    };
  });

  // 收集任务历史提交文件
  const collectHistoryList = ref<any>([]);

  // 完成本收集任务的人员列表
  const collectdUsers = ref<any>([]);

  // 任务是否过期
  const isExpire = computed(() => {
    return +dayjs(collectTask.expireTime) < Date.now();
  });

  // 任务是否不可用
  const isInvalid = computed(() => {
    return !collectTask.status || !collectTask.path;
  });

  // 是否是游客且已登录
  const isVistorLogined = computed(() => vm.$store.getters.isVistorLogined);

  // 是否是网盘用户，且已登录
  const isLogined = computed(() => vm.$store.getters.isLogined);

  // 是否是发起任务人
  const isOwner = computed(
    () => vm.$store.getters.userId === collectTask.userId && vm.$store.getters.orgId === collectTask.orgId,
  );

  const methods = {
    async getCollectInfo() {
      try {
        vm.$store.commit('SET_COLLECT_TOKEN', collectToken);
        // 获取收集任务相关信息
        const {
          data,
        }: {
          data: SMH.CollectTaskData;
        } = await smh.userAPI.getCollectTask({
          collectToken,
        });
        // data.namingRules = methods.mapNameRules(data);
        Object.assign(collectTask, data);
      } catch (e: MsgError) {
        tips.error(e);
      }
    },
    mapNameRules(rule: string) {
      return RULE_LIST_MAP[RULE_LIST_VALUE_MAP[rule] || rule] || rule;
    },
    async getHistoryList() {
      try {
        if (isVistorLogined.value) {
          const { collectToken } = vm.$store.getters;
          const { data } = await smh.commonAPI.getVisitorCollectHistory({
            collectToken,
          });
          collectHistoryList.value = data;
        } else if (isLogined.value) {
          const collectId = collectTask.id;
          const { data } = await smh.userAPI.getCollectHistory({
            collectId,
          });
          collectHistoryList.value = data;
        }
      } catch (e: MsgError) {
        tips.error(e);
      }
    },
    async getUserList() {
      try {
        if (isLogined.value && isOwner.value) {
          const { data } = await smh.userAPI.getCollectStatus({
            collectId: collectTask.id,
          });
          collectdUsers.value = data.submit;
        }
      } catch (e: MsgError) {
        tips.error(e);
      }
    },
  };
  return {
    isInvalid,
    isExpire,
    collectTask,
    orgLogoInfo,
    collectdUsers,
    collectHistoryList,
    methods,
  };
};
